import { useTranslation } from "react-i18next";
import Card from "src/components/Card";
import FormGrid from "src/components/form/FormGrid";
import TaskForm from "src/components/forms/TaskForm";
import SaveTaskButton from "src/components/forms/TaskForm/elements/SaveTaskButton";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import TaskDetailWrapper from "src/components/tasks/detail/TaskDetailWrapper";

export default function EditTaskView() {
	const { t } = useTranslation("task-view", {
		keyPrefix: "edit-view",
	});
	const { task, status } = useTaskForm();

	// useEffect(() => {
	// 	if (!task?.id) {
	// 		actions.get();
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	if (status === "error") {
		return (
			<TaskDetailWrapper loading={false} {...{ task }}>
				<div className="flex flex-1 justify-center items-center flex-col">
					<h2>{t("error.title")}</h2>
				</div>
			</TaskDetailWrapper>
		);
	}

	return (
		<TaskDetailWrapper {...{ task }} loading={status === "loading"}>
			{task?.status === "completed" && status === "idle" && (
				<div className="flex flex-col flex-1 justify-center items-center">
					<div className="flex flex-col max-w-md text-center">
						<strong>{t("disabled.title")}</strong>
						<p>{t("disabled.description")}</p>
					</div>
				</div>
			)}

			{task?.id && status === "idle" && task.status !== "completed" && (
				<>
					<FormGrid>
						<FormGrid.Header
							title={t("cards.description.title")}
						></FormGrid.Header>
						<FormGrid.Card>
							<TaskForm.Description hideButtons />
						</FormGrid.Card>
						<FormGrid.Header title={t("cards.budget.title")}>
							{t("cards.budget.description")}
						</FormGrid.Header>
						<FormGrid.Card>
							<TaskForm.Budget hideButtons />
						</FormGrid.Card>
						<FormGrid.Header
							title={t("cards.location.title")}
						></FormGrid.Header>
						<FormGrid.Card>
							<TaskForm.Address hideButtons />
						</FormGrid.Card>
						<FormGrid.Header
							title={t("cards.date.title")}
						></FormGrid.Header>
						<FormGrid.Card>
							<TaskForm.Target hideButtons />
						</FormGrid.Card>
						<FormGrid.Header
							title={t("cards.form.title")}
						></FormGrid.Header>
						<FormGrid.Card>
							<TaskForm.Interview hideButtons />
						</FormGrid.Card>
						<FormGrid.Header
							title={t("cards.delete.title")}
						></FormGrid.Header>
						<FormGrid.Card>
							<TaskForm.Delete />
						</FormGrid.Card>
					</FormGrid>
					<Card className="sticky bottom-0 z-[60]">
						<div className="flex justify-between items-center">
							<div></div>
							<SaveTaskButton />
						</div>
					</Card>
				</>
			)}
		</TaskDetailWrapper>
	);
}
